import React from 'react';
import clsx from 'clsx';
import { Card } from 'semantic-ui-react';
import OnOffNoLabel from '../OnOffNoLabel';

const SelectableCard = ({
  children,
  className,
  disabled,
  onClick,
  selected,
  single,
}) => (
  <Card.Header className={clsx('aridhia-selectable-card', className)}>
    {onClick && (
    <OnOffNoLabel
      checked={selected}
      className="aridhia-selectable-card-item-toggle"
      disabled={disabled}
      message="hidden.label.select"
      onClick={onClick}
      single={single}
    />
    )}
    {children}
  </Card.Header>
);

export default SelectableCard;
